<template>
  <page>
    <form>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required|start_after_today'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')" :max="new Date()"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.form.fromDate" :max="new Date()"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                 <!-- Policy Type -->
                <v-flex xs12 md6>
                  <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('polType')"
                  :data-vv-as="labels.polType" data-vv-name="polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly
                  v-validate="'required'"></v-text-field>
                </v-flex>
                 <!-- Business Class -->
                <v-flex xs12 md6>
                  <v-text-field v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                  :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="multiBusClsList = true" readonly
                  v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex xs12 sm12 md12 lg12>
        <v-checkbox v-model="form.pbPrtParam" :label="labels.pbPrtParam"></v-checkbox>
        <v-layout class="mt-3 ml-1 d-flex align-center">
          <v-btn class="mr-3" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle class="mr-10" dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-layout>
      </v-flex>
      <v-dialog v-model="multiPolTypeList" width="900px"  >
        <multi-pol-type-exclude-help-list  v-if="multiPolTypeList" :pt="form.polType" :excludePt="form.c11" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-exclude-help-list>
      </v-dialog>
      <v-dialog v-model="multiBusClsList" width="900px"  >
        <multi-bus-cls-exclude-help-list2 v-if="multiBusClsList" :busCls="form.busCls"  :polType="form.polType" :excludePt="form.c11" @close="doClose" @doAssign="doAssignBusCls($event)"></multi-bus-cls-exclude-help-list2>
      </v-dialog>
    </form>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiPolTypeExcludeHelpList from '@/components/core/common/dialog/MultiPolTypeExcludeHelpList'
import MultiBusClsExcludeHelpList2 from '@/components/core/common/dialog/MultiBusClsExcludeHelpList2'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: ' Transaction Date To*',
        export: 'Export to',
        polType: 'Policy Types',
        busCls: 'Business Classes',
        pbPrtParam: 'Print Runtime Parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        format: 'XLSX',
        polType: 'All',
        busCls: 'All',
        c11: 'C11',
        pbPrtParam: true
      },
      menu: {},
      submitting: false,
      // HelpList
      multiPolTypeList: false,
      multiBusClsList: false,
      panel: [0],
      panel2: [0]
    }
  },
  created() {
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
    this.doInit()
  },
  methods: {
    async doClose() {
      this.multiPolTypeList = false
      this.multiBusClsList = false
    },
    async doAssignBusCls(Obj) {
      this.form.busCls = ''
      this.form.busCls = Obj.finalSelectedItems.toString()
    },
    doAssignPolType(Obj) {
      this.form.polType = ''
      this.form.polType = Obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      this.setMenu()
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.uprList
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      result.push(reportFormat.XLSX)
      return result
    },
    toDateValidation() {
      const result = 'required|start_after_today|from_to_date:' + this.form.fromDate
      return result
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiPolTypeExcludeHelpList,
    MultiBusClsExcludeHelpList2
  }
}
</script>
